// extracted by mini-css-extract-plugin
module.exports = {"Form":"Forms_Form__Mnfzo"};